import { IAccessCredentialsPageRequestParams } from "api/entities/access-credential";
import { IPage } from "api/entities/page";
import { accessCredentialsService } from "api/services/application-service";
import Button from "components/shared-ui/button";
import RefreshButton from "components/shared-ui/button/refresh-button";
import PageTitle from "components/shared-ui/pageTitle";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDefaultRequestParams, getEmptyPage } from "redux/reducers/entity";
import { useApi } from "utils/hooks/use-api";
import { routeUtils } from "utils/route-utils";
import { AccessCredentialsTable } from "./access-credentials-table/access-credentials-table";
import styles from "./access-credentials.module.scss";
import { DeleteConfirmation } from "./dialogs/delete-confirmation/delete-confirmation";
import {
  IAMCredentialSortField,
  IIAMCredentialMeta,
  IIAMCredentialUpdateRequest,
} from "api/entities/iam-credentials";
import { IIAMEntityRequestParams } from "api/entities/iam-entity";
import { iamService } from "api/services/iam";
import { CredentialsPanel } from "./panels/credentials-panel/credentials-panel";
import { IIAMUserRequest } from "api/entities/iam-users";

function AccessCredentials() {
  const navigate = useNavigate();

  const [credentialsApi, isCredentialsLoading] = useApi();

  const [IAMCredentialPage, setIAMCredentialPage] = useState<
    IPage<IIAMCredentialMeta>
  >(getEmptyPage<IIAMCredentialMeta>());

  const [requestParams, setRequestParams] = useState<
    IIAMEntityRequestParams<IAMCredentialSortField>
  >({ ...getDefaultRequestParams() });

  function fetchData(
    requestParamsUpdate?: Partial<IAccessCredentialsPageRequestParams>
  ) {
    credentialsApi(iamService.getAccessKeys()).then(setIAMCredentialPage);
  }

  function handleAddCredentialsFormPanelOpen() {
    navigate(routeUtils.getRouteToNewAccessCredentials());
  }

  function handleAddCredentialsFormPanelClose() {
    navigate(routeUtils.getRouteToAccessCredentialList());
  }

  function handleCreateCredentials(createRequest: IIAMUserRequest) {
    return credentialsApi(iamService.createAccessKey(createRequest));
  }

  function handleDeleteApplicationCredential(request: IIAMCredentialUpdateRequest) {
    credentialsApi(iamService.deleteAccessKey(request)).then(() =>
      fetchData({})
    );
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className={styles.header}>
        <PageTitle title={`Access Credentials`}>
          <RefreshButton onClick={() => fetchData(requestParams)} />
        </PageTitle>

        <div className={styles["action-buttons"]}>
          <Button
            testId="create-credentials-button"
            colors="primary"
            onClick={handleAddCredentialsFormPanelOpen}
          >
            Create
          </Button>
        </div>
      </div>

      <AccessCredentialsTable
        isLoading={isCredentialsLoading}
        page={IAMCredentialPage}
        requestParams={requestParams}
        onRequestParamsChanged={fetchData}
        hasManageColumn={true}
      />

      <DeleteConfirmation onDelete={handleDeleteApplicationCredential} />

      <CredentialsPanel
        onClose={handleAddCredentialsFormPanelClose}
        onCreateApplicationCredentials={handleCreateCredentials}
        onRefreshApplicationCredentials={() => fetchData({})}
      />
    </>
  );
}

export default AccessCredentials;
